// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip[data-v-273303d8] {\n  border: 1px solid #b7c4bd;\n  border-radius: 16px;\n  display: inline-block;\n  padding: 2px 4px 2px 14px;\n  margin: 0 0.5rem 0.5rem 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
